<template>

  <nav class="NextPrevPageLinks">

    <a v-if="prev" :href="prev.path" class="link prev">
      <span v-html="arrowLeftSvg" class="icon desktop" />
      <div class="text">
        <div class="label"><span v-html="arrowLeftSvg" class="icon mobile" /> {{ localeStrings.previous }}</div>
        <div class="title">{{ prev.title }}</div>
      </div>
    </a>

    <a v-if="next" :href="next.path" class="link next">
      <div class="text">
        <div class="label">{{ localeStrings.next }} <span v-html="arrowRightSvg" class="icon mobile" /></div>
        <div class="title">{{ next.title }}</div>
      </div>
      <span v-html="arrowRightSvg" class="icon desktop" />
    </a>
  </nav>
</template>

<script>
import strings from '../strings.json'
import arrowLeftSvg from '~/assets/ui/arrow-left.svg?raw'
import arrowRightSvg from '~/assets/ui/arrow-right.svg?raw'

export default {
  inject: ['locale'],
  props: {
    next: {
      type: Object,
      default: null,
    },
    prev: {
      type: Object,
      default: null,
    },
  },
  computed: {
    localeStrings() {
      return strings[this.locale]
    }
  },
  data() {
    return {
      arrowLeftSvg,
      arrowRightSvg,
    }
  },
}
</script>

<style scoped>

.NextPrevPageLinks {
  display: flex;
  column-gap: var(--spacing-5);
}

.link {
  display: flex;
  column-gap: var(--spacing-1);
  transition: filter 0.15s;
}

.link.prev {
  text-align: left;
  margin-right: auto;
}

.link.next {
  text-align: right;
  margin-left: auto;
}

.link:hover {
  filter: brightness(0.75);
}

.icon {
  vertical-align: text-bottom;
}

.icon:deep(svg) {
  display: inline-block;
}

.icon.desktop {
  display: none;
}

.text {
  font-weight: 400;
  font-size: var(--font-size-3);
}

.label {
  color: var(--text-color-black);
  white-space: nowrap;
}

.title {
  color: var(--brand-color);
}

@media (--screen-lg) {

  .icon.mobile {
    display: none;
  }

  .icon.desktop {
    display: inline-block;
  }
}
</style>
